import loadCaptchaScript from './loadCaptchaScript';
import FeedbackDOM from '@/ui/ui_feedback/default-selectors.json';
import CommentsDOM from '@/ui/ui_comments/default-selectors.json';
import ReviewsDOM from '@/ui/ui_reviews/default-selectors.json';
import QuickCheckoutUI from '@/ui/ui_quick-checkout/quick-checkout-selectors.json';
import addViewportFitCover from '@/helpers/addViewportFitCover';

/**
 * @module yandex-captcha/initForUIBlocks
 * @description
 * Инициализирует yandex captcha только для UI-компонентов (обратная связь, отзывы, комментарии, быстрый заказ) внутри commonjs.
 * Не отвечает за инициализацию yandex captcha для всех форм сайта, а только для тех, что реализованы как UI-компоненты в этом модуле.
 *
 * В шаблонах 4 поколения используется Intersection Observer API для ленивой загрузки скрипта yandex captcha, когда элемент с атрибутом data-атрибутом оказывается в зоне видимости.
 *
 * @returns {void}
 */
export default () => {
  window.yandexCaptchaCallbackInsalesCommon = function() {
    window.EventBus.publish('yandex-captcha:insales:loaded');
  };

  const selectors = [
    FeedbackDOM.formYandexCaptcha.attr,
    CommentsDOM.formYandexCaptcha.attr,
    ReviewsDOM.formYandexCaptcha.attr,
    QuickCheckoutUI.yandexCaptcha.value
  ];

  // Находим все элементы, соответствующие селекторам и кладём их в один массив
  const targets = selectors
    .map(sel => Array.from(document.querySelectorAll(sel)))
    .flat();

  if (targets.length === 0) { return; }

  // Функция загрузки скрипта капчи
  let scriptLoaded = false;
  const triggerLoad = () => {
    if (scriptLoaded) { return; }
    scriptLoaded = true;

    // TEM-12602 костыль для андроидов, чтобы появление клавиатуры сдвигало окно с заданием капчи вверх
    addViewportFitCover();

    loadCaptchaScript(
      'yandexCaptchaCallbackInsalesCommon',
      window.yandexCaptchaCallbackInsalesCommon
    );
  };

  // Ждём, пока один из эелементов окажется во вьюпорте
  const onIntersect = (entries, observer) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target.children.length === 0) {
        triggerLoad();
        observer.disconnect();
        break;
      }
    }
  };

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  const observer = new IntersectionObserver(onIntersect, observerOptions);
  targets.forEach(target => observer.observe(target));

  // если после загрузки страницы есть хотя бы один таргет в зоне видимости, то сразу грузим скрипт
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  const anyInView = targets.some(target => {
    const { top, bottom } = target.getBoundingClientRect();

    return top >= 0 && bottom <= viewportHeight && target.children.length === 0;
  });

  if (anyInView) {
    triggerLoad();
    observer.disconnect();
  }
};
